import {Show} from 'platform/foundation';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {TenantProfile as TenantProfileV2} from '../TenantProfile/TenantProfile';
import {TenantProfile} from './components/TenantProfile';

export function Tenant() {
  return (
    <SettingsTemplate
      header={{title: i18n.t('page.settings.labels.tenantProfile')}}
      data-testid="settings-tenant"
    >
      <Show whenFeatureEnabled={featureFlags.TENANT_V2}>
        <TenantProfileV2 />
      </Show>
      <Show whenFeatureDisabled={featureFlags.TENANT_V2}>
        <TenantProfile />
      </Show>
    </SettingsTemplate>
  );
}
